export enum ListReferenceEnum {
  motivation = 0,
  categorie= 1,
  poste = 2,
  juridique =3,
  winpaye = 4,
}
